export const FOCUSED_LOCALS = ['NG', 'GH', 'KE'];
export const SUPPORTED_LOCALS = ['NG', 'GH', 'KE', 'US'];
export const DEFAULT_LOCAL = 'US';

// Static fallbacks so the landing page can render before / without the API.
export const LOCAL_PROFILES = {
  NG: {
    countryCode: 'NG',
    country: 'Nigeria',
    demonym: 'Nigerian',
    heroRegion: 'Nigeria',
    currency: { code: 'NGN', symbol: '₦', name: 'Nigerian Naira', decimals: 0 },
    locale: 'en-NG',
    lingo: 'English (Nigeria)',
    timezone: 'Africa/Lagos',
    city: 'Lagos',
    phoneCountryCode: '+234',
    mobileMoneyLabel: 'Mobile money',
    bookingBusiness: 'Ivory & Coil',
    bookingServices: [
      { name: 'Knotless braids', meta: '3 hr 30 min', amount: 45000 },
      { name: 'Silk press', meta: '1 hr 30 min', amount: 22000 },
      { name: 'Scalp treatment', meta: '45 min', amount: 12000 },
    ],
    paymentExample: {
      total: 18500,
      lines: [
        { label: 'Deep tissue massage', amount: 14000 },
        { label: 'Aromatherapy add-on', amount: 4500 },
        { label: 'Deposit paid online', amount: -5000 },
      ],
    },
    staffNames: ['Zainab', 'Tunde', 'Amara'],
    testimonials: [
      {
        quote:
          'Clients book themselves at midnight and pay their deposit before they arrive. My phone finally stopped buzzing all day.',
        name: 'Amara Okonkwo',
        role: 'Owner',
        business: 'Ivory & Coil, Lagos',
      },
      {
        quote:
          'Everything lives in one place now — the calendar, the till, the client history. My team stopped guessing.',
        name: 'Chinedu Eze',
        role: 'Founder',
        business: 'Crown Room, Abuja',
      },
      {
        quote:
          'Mobile money, card, cash — it all closes out in one report at the end of the night.',
        name: 'Adaobi Nwosu',
        role: 'Spa director',
        business: 'Still Waters, Port Harcourt',
      },
    ],
  },
  GH: {
    countryCode: 'GH',
    country: 'Ghana',
    demonym: 'Ghanaian',
    heroRegion: 'Ghana',
    currency: { code: 'GHS', symbol: 'GH₵', name: 'Ghanaian Cedi', decimals: 2 },
    locale: 'en-GH',
    lingo: 'English (Ghana)',
    timezone: 'Africa/Accra',
    city: 'Accra',
    phoneCountryCode: '+233',
    mobileMoneyLabel: 'Mobile money',
    bookingBusiness: 'Golden Coil',
    bookingServices: [
      { name: 'Knotless braids', meta: '3 hr 30 min', amount: 450 },
      { name: 'Silk press', meta: '1 hr 30 min', amount: 220 },
      { name: 'Scalp treatment', meta: '45 min', amount: 120 },
    ],
    paymentExample: {
      total: 280,
      lines: [
        { label: 'Deep tissue massage', amount: 200 },
        { label: 'Aromatherapy add-on', amount: 80 },
        { label: 'Deposit paid online', amount: -50 },
      ],
    },
    staffNames: ['Ama', 'Kwame', 'Efua'],
    testimonials: [
      {
        quote:
          'Mobile money, card, cash — it all closes out in one report at the end of the night.',
        name: 'Kwame Mensah',
        role: 'Master barber',
        business: 'Highstreet Cuts, Accra',
      },
      {
        quote:
          'Clients book themselves at midnight and pay their deposit before they arrive. My phone finally stopped buzzing all day.',
        name: 'Abena Boateng',
        role: 'Owner',
        business: 'Golden Coil, Accra',
      },
      {
        quote:
          'Everything lives in one place now — the calendar, the till, the client history. My team stopped guessing.',
        name: 'Efua Addo',
        role: 'Founder',
        business: 'Serenity Spa, Kumasi',
      },
    ],
  },
  KE: {
    countryCode: 'KE',
    country: 'Kenya',
    demonym: 'Kenyan',
    heroRegion: 'Kenya',
    currency: { code: 'KES', symbol: 'KSh', name: 'Kenyan Shilling', decimals: 0 },
    locale: 'en-KE',
    lingo: 'English (Kenya)',
    timezone: 'Africa/Nairobi',
    city: 'Nairobi',
    phoneCountryCode: '+254',
    mobileMoneyLabel: 'M-Pesa',
    bookingBusiness: 'Baraka Studio',
    bookingServices: [
      { name: 'Knotless braids', meta: '3 hr 30 min', amount: 4500 },
      { name: 'Silk press', meta: '1 hr 30 min', amount: 2200 },
      { name: 'Scalp treatment', meta: '45 min', amount: 1200 },
    ],
    paymentExample: {
      total: 6400,
      lines: [
        { label: 'Deep tissue massage', amount: 4800 },
        { label: 'Aromatherapy add-on', amount: 1600 },
        { label: 'Deposit paid online', amount: -2000 },
      ],
    },
    staffNames: ['Wanjiru', 'Otieno', 'Naledi'],
    testimonials: [
      {
        quote:
          'Everything lives in one place now — the calendar, the till, the client history. My team stopped guessing.',
        name: 'Wanjiru Kamau',
        role: 'Founder',
        business: 'Baraka Spa, Nairobi',
      },
      {
        quote:
          'Clients book themselves at midnight and pay their deposit before they arrive. My phone finally stopped buzzing all day.',
        name: 'Amina Hassan',
        role: 'Owner',
        business: 'Coast Curl, Mombasa',
      },
      {
        quote:
          'M-Pesa, card, cash — it all closes out in one report at the end of the night.',
        name: 'Brian Otieno',
        role: 'Barber',
        business: 'Kileleshwa Cuts, Nairobi',
      },
    ],
  },
  // Fallback for everywhere outside NG / GH / KE — USD, no country callout in the hero.
  US: {
    countryCode: 'US',
    country: 'United States',
    demonym: 'African',
    heroRegion: null,
    currency: { code: 'USD', symbol: '$', name: 'US Dollar', decimals: 2 },
    locale: 'en-US',
    lingo: 'English',
    timezone: 'America/New_York',
    city: null,
    phoneCountryCode: '+1',
    mobileMoneyLabel: 'Mobile money',
    bookingBusiness: 'Ivory & Coil',
    bookingServices: [
      { name: 'Knotless braids', meta: '3 hr 30 min', amount: 180 },
      { name: 'Silk press', meta: '1 hr 30 min', amount: 85 },
      { name: 'Scalp treatment', meta: '45 min', amount: 45 },
    ],
    paymentExample: {
      total: 96,
      lines: [
        { label: 'Deep tissue massage', amount: 75 },
        { label: 'Aromatherapy add-on', amount: 21 },
        { label: 'Deposit paid online', amount: -25 },
      ],
    },
    staffNames: ['Amara', 'Tunde', 'Naledi'],
    testimonials: [
      {
        quote:
          'Clients book themselves at midnight and pay their deposit before they arrive. My phone finally stopped buzzing all day.',
        name: 'Amara Okonkwo',
        role: 'Owner',
        business: 'Ivory & Coil, Lagos',
      },
      {
        quote:
          'Everything lives in one place now — the calendar, the till, the client history. My team stopped guessing.',
        name: 'Wanjiru Kamau',
        role: 'Founder',
        business: 'Baraka Spa, Nairobi',
      },
      {
        quote:
          'Mobile money, card, cash — it all closes out in one report at the end of the night.',
        name: 'Kwame Mensah',
        role: 'Master barber',
        business: 'Highstreet Cuts, Accra',
      },
    ],
  },
};

export const normalizeLocalParam = (value) => {
  if (!value) return null;
  const raw = String(value).trim().toUpperCase();
  if (LOCAL_PROFILES[raw]) return raw;
  const byName = {
    NIGERIA: 'NG',
    GHANA: 'GH',
    KENYA: 'KE',
    US: 'US',
    USA: 'US',
    'UNITED STATES': 'US',
    INTERNATIONAL: 'US',
    // Currency codes sometimes pasted as locale overrides
    NGN: 'NG',
    GHS: 'GH',
    KES: 'KE',
    USD: 'US',
  };
  return byName[raw] || null;
};

// Focused markets stay as-is; anything else (or unknown) falls back to US.
export const resolveLocalCode = (value) => {
  const code = normalizeLocalParam(value);
  if (code && FOCUSED_LOCALS.includes(code)) return code;
  if (code === 'US') return 'US';
  return DEFAULT_LOCAL;
};

/**
 * Infer market from a business phone E.164 (or dial-prefixed) number.
 * +233 → GH, +234 → NG, +254 → KE, +1 → US.
 */
export const localCodeFromPhone = (phone) => {
  if (!phone) return null;
  const normalized = String(phone).replace(/[^\d+]/g, '');
  if (!normalized) return null;

  const dials = [
    { prefix: '+233', code: 'GH', minLen: 12 },
    { prefix: '+234', code: 'NG', minLen: 13 },
    { prefix: '+254', code: 'KE', minLen: 12 },
    { prefix: '+1', code: 'US', minLen: 11 },
  ];

  for (const { prefix, code, minLen } of dials) {
    if (normalized.startsWith(prefix) && normalized.length >= minLen) return code;
    const bare = prefix.slice(1);
    if (
      !normalized.startsWith('+') &&
      normalized.startsWith(bare) &&
      normalized.length >= minLen - 1
    ) {
      return code;
    }
  }

  return null;
};

/**
 * Workspace currency resolution.
 * Priority:
 * 1. URL locale override (?locale=gh|local|country) when hasLocaleOverride
 * 2. Business country
 * 3. Business phone dial country
 * 4. Stored business.currency
 * 5. Detected / active localization profile
 * 6. USD
 */
export const resolveWorkspaceCurrency = ({
  business = null,
  localCode = null,
  hasLocaleOverride = false,
} = {}) => {
  if (hasLocaleOverride && localCode) {
    return LOCAL_PROFILES[resolveLocalCode(localCode)]?.currency?.code || 'USD';
  }

  if (business?.country) {
    const fromCountry = LOCAL_PROFILES[resolveLocalCode(business.country)]?.currency?.code;
    if (fromCountry) return fromCountry;
  }

  const phoneLocal = localCodeFromPhone(business?.phone);
  if (phoneLocal) {
    return LOCAL_PROFILES[phoneLocal]?.currency?.code || 'USD';
  }

  if (business?.currency) return business.currency;

  if (localCode) {
    return LOCAL_PROFILES[resolveLocalCode(localCode)]?.currency?.code || 'USD';
  }

  return 'USD';
};

// Lookup table keyed by ISO currency code (NGN, GHS, KES, USD).
export const CURRENCY_BY_CODE = Object.fromEntries(
  Object.values(LOCAL_PROFILES).map((profile) => [
    profile.currency.code,
    {
      code: profile.currency.code,
      symbol: profile.currency.symbol,
      decimals: profile.currency.decimals,
      locale: profile.locale,
    },
  ])
);

export const getCurrencyMeta = (currencyCode) =>
  CURRENCY_BY_CODE[currencyCode] || CURRENCY_BY_CODE.USD;

export const formatLocalMoney = (amount, profile) => {
  const currency = profile?.currency?.code || 'USD';
  const locale = profile?.locale || 'en-US';
  const decimals = profile?.currency?.decimals ?? 2;
  try {
    return new Intl.NumberFormat(locale, {
      style: 'currency',
      currency,
      maximumFractionDigits: decimals,
      minimumFractionDigits: decimals,
    }).format(Number(amount) || 0);
  } catch {
    return `${profile?.currency?.symbol || currency} ${Number(amount) || 0}`;
  }
};

/** Format money from a currency code alone (workspace / booking UI). */
export const formatMoneyByCurrency = (amount, currencyCode = 'USD') => {
  const currency = currencyCode || 'USD';
  const known = CURRENCY_BY_CODE[currency];
  const locale = known?.locale || 'en-US';
  const decimals = known?.decimals ?? 2;
  try {
    return new Intl.NumberFormat(locale, {
      style: 'currency',
      currency,
      maximumFractionDigits: decimals,
      minimumFractionDigits: decimals,
    }).format(Number(amount) || 0);
  } catch {
    return `${known?.symbol || currency} ${Number(amount) || 0}`;
  }
};

export const formatLocalAmount = (amount, profile) => {
  const locale = profile?.locale || 'en-US';
  const decimals = profile?.currency?.decimals ?? 2;
  try {
    return new Intl.NumberFormat(locale, {
      maximumFractionDigits: decimals,
      minimumFractionDigits: decimals,
    }).format(Number(amount) || 0);
  } catch {
    return String(Number(amount) || 0);
  }
};
